import { Button } from "@chakra-ui/react"
import React from "react"
import { useAuth0 } from "src/auth/useAuth-compat"
import { dashboardApiUrl } from "../../api/base-url"

function UpdateTaxiCompaniesInMetabaseButton() {
  const { getAccessTokenSilently } = useAuth0()

  async function updateTaxiCompaniesInMetabase() {
    const accessToken = await getAccessTokenSilently()
    const url = dashboardApiUrl(`/resend-companies-metabase`)
    try {
      const response = await fetch(url, {
        credentials: "include",
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      const jsonResponse = await response.json()
      if (jsonResponse.updateSuccessfully) {
        alert("Alle taxiselskapene ble oppdatert")
      } else {
        alert("Klarte ikke å oppdatere taxiselskapene.")
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Button variant="secondary" onClick={updateTaxiCompaniesInMetabase}>
      Oppdater
    </Button>
  )
}

export default UpdateTaxiCompaniesInMetabaseButton
